import React, { useState, useEffect } from 'react';
import { Dropdown } from 'react-bootstrap';
import moment from 'moment';
import { Calendar } from "react-date-range-patched";
import "react-date-range-patched/styles.scss";
import "react-date-range-patched/theme/default.scss";
import CustomButton from "../../CustomButton";

export default function CalendarDropdown(props) {
    const { date, id = 'calendar-dropdown', displayFormat = 'MM/DD/YYYY', onChange, footer, ...rest } = props;
    const [selectedDate, setSelectedDate] = useState(date || moment());
    const [isOpen, setIsOpen] = useState(false);

    const handleChange = (date) => {
        setSelectedDate(date);
        onChange(date);
        setIsOpen(false);
    };

    useEffect(() => {
        setSelectedDate(date);
    }, [date]);

    return (
        <Dropdown
            id={id}
            className="calendar-dropdown"
            role="menuitem"
            show={isOpen}
            onToggle={(isOpen) => setIsOpen(isOpen)}
            drop
        >
            <Dropdown.Toggle
                as={CustomButton}
                variant="primary-outline"
                size="lg"
                prefix="drop-down-toggle w-100"
                type="button"
            >
                {moment(selectedDate).format(displayFormat)}
            </Dropdown.Toggle>

            <Dropdown.Menu className="date-select">
                {isOpen ? (
                    <Calendar
                        date={moment(selectedDate).toDate()}
                        onChange={handleChange}
                        showMonthAndYearPickers={true}
                        preventAutoFocus={true}
                        {...rest}
                    />
                ) : ''}
                {footer ? <div className="calendar-footer">
                    {footer}
                </div> : ''}
            </Dropdown.Menu>
        </Dropdown>
);
}
